import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-619a6038")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-flex-column p-ai-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Sobre el plan")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-flex-column p-ai-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Unidades")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-flex-column p-ai-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Previo al inicio")
], -1)
const _hoisted_4 = { class: "p-d-flex p-jc-end p-ai-center" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AboutPlanTab = _resolveComponent("AboutPlanTab")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_UnitSyllabus = _resolveComponent("UnitSyllabus")!
  const _component_AboutPreviousToPlanTab = _resolveComponent("AboutPreviousToPlanTab")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TabView, { class: "icon-center-tabview" }, {
      default: _withCtx(() => [
        _createVNode(_component_TabPanel, { class: "p-pl-4" }, {
          header: _withCtx(() => [
            _hoisted_1
          ]),
          default: _withCtx(() => [
            _createVNode(_component_AboutPlanTab, {
              careerPlans: _ctx.careerPlans,
              coursePlans: _ctx.coursePlans,
              educationPlan: _ctx.educationPlan,
              name: _ctx.formValues.information.name,
              "onUpdate:name": _cache[0] || (_cache[0] = ($event: any) => (_ctx.formValues.information.name = $event)),
              path: _ctx.formValues.links.path,
              "onUpdate:path": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formValues.links.path = $event)),
              shortDescription: _ctx.formValues.information.shortDescription,
              "onUpdate:shortDescription": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formValues.information.shortDescription = $event)),
              longDescription: _ctx.formValues.information.longDescription,
              "onUpdate:longDescription": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formValues.information.longDescription = $event)),
              careerCourses: _ctx.formValues.courses,
              "onUpdate:careerCourses": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formValues.courses = $event)),
              difficulty: _ctx.formValues.information.dedication.difficulty,
              "onUpdate:difficulty": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formValues.information.dedication.difficulty = $event)),
              laptopRequired: _ctx.formValues.laptopRequired,
              "onUpdate:laptopRequired": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formValues.laptopRequired = $event)),
              preSale: _ctx.formValues.preSale,
              "onUpdate:preSale": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formValues.preSale = $event)),
              published: _ctx.formValues.published,
              "onUpdate:published": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formValues.published = $event)),
              display: _ctx.formValues.display,
              "onUpdate:display": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formValues.display = $event)),
              config: _ctx.formValues.config,
              "onUpdate:config": _cache[10] || (_cache[10] = ($event: any) => (_ctx.formValues.config = $event))
            }, null, 8, ["careerPlans", "coursePlans", "educationPlan", "name", "path", "shortDescription", "longDescription", "careerCourses", "difficulty", "laptopRequired", "preSale", "published", "display", "config"])
          ]),
          _: 1
        }),
        (_ctx.isCoursePlan(_ctx.educationPlan))
          ? (_openBlock(), _createBlock(_component_TabPanel, { key: 0 }, {
              header: _withCtx(() => [
                _hoisted_2
              ]),
              default: _withCtx(() => [
                _createVNode(_component_UnitSyllabus, {
                  coursePlanId: _ctx.educationPlan.id
                }, null, 8, ["coursePlanId"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_TabPanel, null, {
          header: _withCtx(() => [
            _hoisted_3
          ]),
          default: _withCtx(() => [
            _createVNode(_component_AboutPreviousToPlanTab, {
              coursePlans: _ctx.coursePlans,
              preKnowledge: _ctx.formValues.information.preKnowledge,
              "onUpdate:preKnowledge": _cache[11] || (_cache[11] = ($event: any) => (_ctx.formValues.information.preKnowledge = $event)),
              postSkills: _ctx.formValues.information.postSkills,
              "onUpdate:postSkills": _cache[12] || (_cache[12] = ($event: any) => (_ctx.formValues.information.postSkills = $event)),
              requeriments: _ctx.formValues.information.requeriments,
              "onUpdate:requeriments": _cache[13] || (_cache[13] = ($event: any) => (_ctx.formValues.information.requeriments = $event))
            }, null, 8, ["coursePlans", "preKnowledge", "postSkills", "requeriments"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Button, {
        disabled: _ctx.publishing,
        onClick: _ctx.publish,
        class: "p-ml-5 p-mr-5 p-mt-0 p-mb-0",
        label: _ctx.formValues.published ? 'Despublicar' : 'Publicar'
      }, null, 8, ["disabled", "onClick", "label"]),
      _createVNode(_component_Button, {
        disabled: _ctx.saving,
        onClick: _ctx.save,
        class: "p-ml-5 p-mr-5 p-mt-0 p-mb-0",
        label: "Guardar"
      }, null, 8, ["disabled", "onClick"])
    ])
  ], 64))
}